export {default as timeFormatDefaultLocale, timeFormat, timeParse, utcFormat, utcParse} from "./src/defaultLocale";
export {default as timeFormatLocale} from "./src/locale";
export {default as isoFormat} from "./src/isoFormat";
export {default as isoParse} from "./src/isoParse";



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-time-format/index.js
// module id = MM8I
// module chunks = 0